// 电影相关接口
import {request} from "@/utils/request.js";

/**
 * 获取电影信息
 *
 */
export function getMovieInfo(data) {
	return request.post('fusl/movieInfo', data, {
		noAuth: true
	});
}
export function searchMovieInfo(data) {
	return request.post('fusl/movieSearch', data, {
		noAuth: true
	});
}
/**
 * 获取电影列表
 *
 */
export function getMovieList(data) {
	return request.post('fusl/movieList', data, {
		noAuth: true
	});
}
/**
 * 获取全国城市列表
 *
 */
export function getCityList(data = {}) {
	return request.get('kp/cityList', {params:data}, {
		noAuth: true
	});
}
/**
 * 获取有排期的影院列表
 *
 */
export function getCinemaList(data = {}) {
	return request.post('fusl/movieNow', data, {
		noAuth: true
	});
}
/**
 * 获取所有影院列表
 *
 */
export function getAllCinemaList(data = {}) {
	return request.post('fusl/cinemaList', data, {
		noAuth: true
	});
}

/**
 * 获取影院信息
 *
 */
export function getCinemaInfo(data = {}) {
	return request.post('fusl/cinemaInfo', data, {
		noAuth: true
	});
}
/**
 * 获取影院电影场次信息
 *
 */
export function getCinemaMoviesInfo(data = {}) {
	return request.post('fusl/show', data, {
		noAuth: true
	});
}
/**
 * 获取城市坐标
 *
 */
export function getCityLocation(data = {}) {
	return request.get('getCity', {params:data}, {
		noAuth: true
	});
}
/**
 * 获取所有城市
 *
 */
export function getAllCity(data = {}) {
	return request.get('fusl/cityList', {params: data}, {
		noAuth: true
	});
}
/**
 * 获取所有已开通的城市
 *
 */
export function getOpenCity(data = {}) {
	return request.get('fusl/getCityListByCode', {params: data}, {
		noAuth: true
	});
}
/**
 * 电影订单新增
 *
 */
export function addFilmOrder(data = {}) {
	return request.post('cart/addMovie', data, {
		noAuth: true
	});
}
/**
 * 电影订单详情
 *
 */
export function getFilmOrderDetail(data = {}) {
	return request.post('order/confirmMovie', data, {
		noAuth: true
	});
}
/**
 * 获取黄牛订单列表
 *
 */
export function getCattleOrderList(data = {}) {
	return request.get('order/movieList/' + data.type, {params:data}, {
		noAuth: true
	});
}
/**
 * 锁定订单
 *
 */
export function lockOrder(data = {}) {
	return request.post('order/movieOrderLock/' + data.order_id, data, {
		noAuth: true
	});
}
/**
 * 解锁订单
 *
 */
export function unlockOrder(data = {}) {
	return request.post('order/movieOrderUnlock/' + data.order_id, data, {
		noAuth: true
	});
}
/**
 * 出票
 *
 */
export function ticketing(data = {}) {
	return request.post('order/movieOrderTicketCode/' + data.order_id, data, {
		noAuth: true
	});
}
/**
 * 识别二维码
 *
 */
export function identifyingQRCodes(data = {}) {
	return request.post('getQrcode', data, {
		noAuth: true
	});
}
/**
 * 锁定座位
 *
 */
export function lockSeat(data = {}) {
	return request.post('fusl/lock', data, {
		noAuth: true
	});
}
/**
 * 获取座位列表
 *
 */
export function getSeatList(data = {}) {
	return request.post('fusl/seat', data, {
		noAuth: true
	});
}
/**
 * 获取token
 *
 */
export function getToken(data = {}) {
	return request.post('access_token_h5', data, {
		noAuth: true
	});
}

/**
 * 获取 逆地址解析 获取城市名称
 *
 */
export function getCityName( data = {}) {

	return request.post('getCityName', data, {
		noAuth: true
	});

	// let key = 'X4RBZ-ZOKWZ-RG3XR-THWDM-ZKQLV-AKFLS';
	// console.log('定位开始 data ' ,data );
	// let url = 'https://apis.map.qq.com/ws/geocoder/v1/?location=' +  data.lat + ',' +  data.lng +
	// 	'&key=' + key;
	// // console.log('定位开始 url ' ,url);
	// return request.get(url, data, {
	// 	noAuth: true
	// });
}

/**
 * 获取 ip
 */
export function getCityNameByIP( data = {}) {
	return request.post('getCityNameByIP', data, {
		noAuth: true
	});
}